import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import { PlaceHolder } from "../../../../../Entryfile/imagepath";
import Api from "../../../../../initialpage/hooks/Api";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
import { imageApi } from "../../../../../initialpage/hooks/HrApi";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import { Form, message, Upload } from "antd";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

function getBase64(file, callback) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => callback(reader.result);
  reader.onerror = (error) => console.error("Base64 error:", error);
}

const StockProducts = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [limit, setLimit] = useState(10);
  const [imageUrl, setImageUrl] = useState(null);
  const [photoPath, setPhotoPath] = useState("");
  const [imageStore, setImageStore] = useState("");
  const [loading, setLoading] = useState(false);
  const { data: categoryOption, error } = useSWR(
    `store/settings/categories?page=${0}&limit=${10000}`,
    fetcher1
  );

  const {
    data: categoryBox,
    error: error2,
    mutate: mutate1,
  } = useSWR(`store/products/manageproducts`, fetcher);

  console.log(categoryBox);

  const {
    data: productData,
    error: error1,
    mutate,
  } = useSWR(
    `store/products/storeProducts?page=${pageIndex}&limit=${limit}`,
    fetcher1
  );

  const [selectedCategory, setSelectedCategory] = useState("");
  const [search, setSearch] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  // get UnitData
  const { data: unitOption, error: error3 } = useSWR(
    `store/settings/units?page=${0}&limit=${10000}`,
    fetcher1
  );
  // set Unit select list
  console.log(productData);
  let unitCategory = [];
  if (unitOption && unitOption.length > 0) {
    unitCategory = unitOption.map((data) => {
      // console.log(data);
      let optionsItem = {};
      optionsItem.value = data.unit_id;
      optionsItem.label = `${data.unit}`;
      return optionsItem;
    });
  }
  // handle Unit select;
  const handleUnit = (name) => {
    setSelectedUnit(name.value);
  };

  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }

  const handleCategory = (name) => {
    // console.log(name.value);
    setSelectedCategory(name.value);
  };

  // react hook form
  const { register, handleSubmit, reset } = useForm();
  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();

  // Update Section
  const [getId, setGetId] = useState(null);
  // get product Data By ID
  const { data: productById, mutate: mutate2 } = useSWR(
    getId ? `store/products/getStoreProductByListId/${getId}` : null,
    fetcher
  );

  useEffect(() => {
    const getUserDetails = () => {
      setImageUrl(
        productById.PROIMAGE == null ? "" : `${imageApi}${productById.PROIMAGE}`
      );
    };

    if (productById) getUserDetails();
  }, [productById]);
  //
  console.log(getId);
  //   Update store product
  const onSubmitUpdate = (data) => {
    if (selectedCategory) {
      data.procate = parseInt(selectedCategory);
    } else {
      data.procate = productById.PROCATE;
    }
    if (selectedUnit) {
      data.prounit = parseInt(selectedUnit);
    } else {
      data.prounit = productById.PRODUNIT;
    }
    if (!data.proname) {
      data.proname = productById.PRONAME;
    }
    if (!data.pro_name_two) {
      data.pro_name_two = productById.PRONAMETWO;
    }

    if (data.stockalert) {
      data.stockalert = parseInt(data.stockalert);
    } else {
      data.stockalert = productById.STOCKALERT;
    }
    if (data.proqty) {
      data.proqty = parseInt(data.proqty);
      console.log(parseInt(data.proqty));
    } else {
      data.proqty = parseInt(productById.PROQTY);
      console.log(parseInt(productById.PROQTY));
    }
    if (data.stockprice) {
      data.stockprice = parseInt(data.stockprice);
    } else {
      data.stockprice = productById.STOCKPRICE;
    }

    if (data.status && productById) {
      data.status = parseInt(data.status);
    } else {
      data.status = productById.PROTSTATUS;
    }
    if (photoPath) {
      data.proimage = photoPath;
    } else {
      data.proimage = productById.PROIMAGE;
    }

    data.proid = getId;
    data.prod_list_id = productById.PROD_LIST_ID;

    console.log(data);

    API.put("store/products/updateProductList", data).then((res) => {
      //console.log(res.data);
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(2, "store product update");
        window.$("#edit_stock_product").modal("hide");
        reset1();
        window.location.reload();
        mutate2();
      }
    });
  };
  // Get product Id
  const handleUpdate = (updateId) => {
    // console.log(updateId);
    setGetId(updateId);
  };

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    // console.log(search);
    setSearch(search);
    let limit = search === "" ? 10 : 1000;
    const res = await API.get(
      search ? `store/products/storeProducts?page=${0}&limit=${limit}` : null,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate([], false);
    }
  };

  let counter = 1;

  const handleBeforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    getBase64(file, async (base64Url) => {
      setImageUrl(base64Url);

      try {
        const response = await fetch(`${imageApi}/upload-base64/store`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ base64Image: base64Url }),
        });

        if (!response.ok) throw new Error(`Server error: ${response.status}`);
        const data = await response.json();
        setPhotoPath(data.path);
      } catch (error) {
        console.error("Base64 upload failed:", error);
        message.error("Image upload failed! Is the server running?");
      }
    });

    return false;
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload Photo</div>
    </div>
  );

  // console.log(imageStore);
  return (
    <>
      <Helmet>
        <title>Product -  STORE</title>
        <meta name="description" content="Product  -  STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
            {categoryBox ? (
              <h3 className="text-start text-dark mb-2">
                Store Products (
                <span
                  style={{
                    color: "#d80017",
                  }}
                >
                  Product Entries : {categoryBox?.totalProducts}, Total
                  Quantities:
                  {parseInt(categoryBox?.totalquantites)?.toFixed(2)}
                </span>{" "}
                )
              </h3>
            ) : (
              ""
            )}
          </div>
          {categoryBox ? (
            <div className="col-12 col-md-12 col-lg-12">
              <input
                className="p-2 input-field_store w-100"
                type="text"
                name="Search"
                onChange={(e) => handleSearch(e)}
                placeholder="Search Products"
              />
            </div>
          ) : (
            <NotFoundPage></NotFoundPage>
          )}

          {search.length > 0 && productData.length ? (
            <div
              className="my-4 table-container p-2"
              style={{ background: "white", borderRadius: "10px" }}
            >
              <div className="d-flex justify-content-between align-items-center search-div_store">
                {/* <div className="col-12 col-md-6 col-lg-4">
                  <p className="text-start mt-4 fs-6 text-black-50">
                    Show Entries
                    <select
                      onClick={(e) => {
                        setLimit(parseInt(e.target.value));
                      }}
                      className="ms-2 btn-outline-color "
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </p>
                </div> */}

                {/* <div className="col-12 col-md-6 col-lg-4">
                  <input
                    className="p-2 input-field_store w-100"
                    type="text"
                    name="Search"
                    onChange={(e) => handleSearch(e)}
                    placeholder="Search Products"
                  />
                </div> */}
              </div>
              <div className="table-responsive data-table_store">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th colSpan="1">S/N</th>
                      <th colSpan="1">Product</th>
                      <th colSpan="1">Unit</th>
                      <th colSpan="1">Current Stock</th>
                      <th colSpan="1">Status</th>
                      <th colSpan="1">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productData.map((item) => (
                      <tr key={counter}>
                        <th className="text-center">{counter++}</th>
                        <td>
                          <div className="d-flex">
                            <div>
                              {item.PROIMAGE && item.PROIMAGE != "null" ? (
                                <img
                                  data-toggle="modal"
                                  className="me-2 "
                                  width={50}
                                  height={50}
                                  data-target="#showImage"
                                  src={`${imageApi}${item.PROIMAGE}`}
                                  onClick={() => setImageStore(item.PROIMAGE)}
                                />
                              ) : (
                                <img
                                  src={PlaceHolder}
                                  alt=""
                                  width={50}
                                  height={50}
                                  className="me-2 "
                                />
                              )}
                            </div>
                            <div>
                              {item.PRONAMETWO}
                              <br />({item.PRONAME})
                            </div>
                          </div>
                        </td>
                        <td>{item.UNIT}</td>
                        <td className="text-center">{item.PROQTY}</td>
                        <td className="text-center pt-3">
                          {item.PROTSTATUS === 1 ? (
                            <span className="bg-success text-white px-3 py-1  rounded-3">
                              Publish
                            </span>
                          ) : (
                            <span className="bg-success text-white px-3 py-1 rounded-3">
                              Unpublish
                            </span>
                          )}
                        </td>
                        <td className="text-center">
                          <button
                            data-bs-toggle="tooltip"
                            title="Edit"
                            data-toggle="modal"
                            data-target="#edit_stock_product"
                            onClick={() => {
                              handleUpdate(item.PROID);
                            }}
                            type="button"
                            className="btn btn-outline-color px-3 me-2"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {search.length > 0 ? (
                <div></div>
              ) : (
                <div className="text-end mt-4 mb-3">
                  {pageIndex > 0 && (
                    <button
                      type="button"
                      className="btn btn-outline-color_store px-4 me-2"
                      onClick={() => setPageIndex(pageIndex - 1)}
                    >
                      Previous
                    </button>
                  )}

                  {productData && productData.length === limit ? (
                    <button
                      type="button"
                      className="btn btn-outline-color_store px-4 me-2"
                      onClick={() => setPageIndex(pageIndex + 1)}
                    >
                      Next
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          ) : (
            ""
          )}

          {/* Product By Category */}
          <div className="my-4 ">
            <div className="row m-0">
              {categoryBox
                ? categoryBox.categories.map((item) => (
                  <div className="col-12 col-md-6 my-2 col-lg-6 ">
                    <Link to={`/product/cateproducts/${item.CAT_ID}`}>
                      <div
                        className="d-flex  align-items-center"
                        style={{
                          boxShadow:
                            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                          borderRadius: "5px",
                        }}
                      >
                        <div className="px-5 py-4 tableColor custom-background_store rounded-start  ">
                          <i className="fa fa-gift text-white fs-1 mt-2"></i>
                        </div>
                        <div className="ms-3 lh-1">
                          <h4
                            className="lh-1  pt-1 fs-5"
                            style={{
                              fontFamily:
                                "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "600",
                            }}
                          >
                            {item.CATEGORYEN
                              ? item.CATEGORYEN.toUpperCase()
                              : ""}
                          </h4>
                          <h5 className="lh-1 fw-normal text-start">
                            {item.CATEGORYBN ? item.CATEGORYBN : ""}
                          </h5>
                          <p
                            className="text-start fs-5 "
                            style={{
                              color: "#d80017",
                              fontWeight: "600",
                            }}
                          >
                            <a href="#">{item.PRODUCTS}</a>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
                : ""}
            </div>
          </div>
          {/* {!productData ? (
            <NotFoundPage />
          ) : (
           
          )} */}
        </div>
      </div>
      {/* Edit product list Modal */}
      <div
        id="edit_stock_product"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Edit Category Wise Product Information
              </h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body text-start">
              <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                <div className="container px-4">
                  <div className="row mx-3">
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Bangla Name
                        </label>
                        <input
                          type="text"
                          className="form-control p-2 input-field_store"
                          id="exampleFormControlInput1"
                          {...register1("pro_name_two")}
                          defaultValue={
                            productById ? productById.PRONAMETWO : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table_store ">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          English Name
                        </label>
                        <input
                          type="text"
                          className="form-control p-2 input-field_store"
                          id="exampleFormControlInput1"
                          {...register1("proname")}
                          defaultValue={productById ? productById.PRONAME : ""}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table ">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Category
                        </label>
                        <Select
                          onChange={handleCategory}
                          className="text-start fs-6"
                          placeholder={
                            productById
                              ? `${productById.CATEGORYEN}(${productById.CATEGORYBN})`
                              : "Select"
                          }
                          options={category}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table ">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Unit
                        </label>
                        <Select
                          onChange={handleUnit}
                          className="text-start fs-6"
                          placeholder={
                            productById ? productById.UNIT : "Select"
                          }
                          options={unitCategory}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table ">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Product Status
                        </label>
                        <select
                          className="form-select fs-6"
                          aria-label="Default select example"
                          {...register1("status")}
                        >
                          {productById && (
                            <option value={productById.PROTSTATUS} selected>
                              {productById.PROTSTATUS === 1
                                ? "Publish"
                                : "Unpublish"}
                            </option>
                          )}
                          <option value="1">Publish</option>
                          <option value="0">Unpublish</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Current Stock
                        </label>
                        <input
                          type="number"
                          {...register1("proqty")}
                          defaultValue={productById ? productById.PROQTY : ""}
                          className="form-control p-2 input-field_store"
                          id="exampleFormControlInput1"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 data-table_store ">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Stock Alert
                        </label>
                        <input
                          type="number"
                          {...register1("stockalert")}
                          defaultValue={
                            productById ? productById.STOCKALERT : ""
                          }
                          className="form-control p-2 input-field_store"
                          id="exampleFormControlInput1"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6 col-lg-6 data-table_store ">
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Stock Price
                        </label>
                        <input
                          type="number"
                          {...register1("stockprice")}
                          defaultValue={
                            productById ? parseInt(productById.STOCKPRICE) : ""
                          }
                          className="form-control p-2 input-field_store"
                          id="exampleFormControlInput1"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 data-table_store ">
                      <Form.Item label="Product Photo">
                        <Upload
                          name="avatar"
                          listType="picture-card"
                          className="avatar-uploader"
                          showUploadList={false}
                          beforeUpload={handleBeforeUpload}
                        >
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt="avatar"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            uploadButton
                          )}
                        </Upload>
                      </Form.Item>
                    </div>
                  </div>
                </div>

                <div className="submit-section">
                  <button
                    type="submit"
                    className="btn btn-color_store text-white px-5 py-2 rounded"
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-color_store text-white px-5 ms-1 py-2 rounded"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal bg-dark custom-modal fade"
        id="showImage"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content bg-dark">
            <div className="modal-header">
              <h5 className="modal-title text-light">Store Product Photo</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <img
                  className="img-fluid"
                  alt="Responsive image"
                  style={{
                    width: "350px",
                    height: "350px",
                  }}
                  src={`${imageApi}${imageStore}`}
                />
              </div>
            </div>
            <div className="submit-section">
              <button
                type="button"
                className="btn btn-color_store text-white px-5 ms-1 py-2 mb-3 rounded"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StockProducts;
